import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getServizi = gql`
  ${seoFragment}
  query GetServizi($site: [String]) {
    serviziPageEntries(site: $site) {
      ... on serviziPage_Entry {
        id
        seo {
          ...SeoFragment
        }
        generalHeader {
          ... on generalHeader_Entry {
            id
            generalHeaderTitle
            generalHeaderText
            sezioneImmagineVideoFull {
              ... on sezioneImmagineVideoFull_Entry {
                imageVideoTitle
                imageVideoText
                fullVideoUrlPreview
                fullVideoUrl
                fullVideoButtonText
                fullImage {
                  id
                  title
                }
                landscape: fullImage
                  @transform(format: "webp", width: 3840, height: 2160) {
                  id
                  url
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  width
                  height
                  title
                }
                mobile: fullImageMobile
                  @transform(format: "webp", width: 1000, height: 1500) {
                  id
                  url
                  width
                  srcset(sizes: ["750w", "1000w"])
                  height
                  title
                }
              }
            }
          }
        }
        carosello {
          ... on carosello_Entry {
            sectionTitle
            text
            mostraBottoneCarosello {
              ... on mostraBottoneCarosello_Entry {
                linkDefault
                label
              }
            }
            slide {
              ... on slide_Entry {
                sectionTitle
                coloreTitolo
                title
                text
                label
                linkDefault
                portrait: immagine
                  @transform(format: "webp", width: 200, height: 200) {
                  id
                  url
                  srcset(sizes: ["750w", "1000w"])
                  width
                  height
                  title
                }
                custom: immagine @transform(width: 1200, height: 1200) {
                  id
                  url
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  width
                  height
                  title
                }
                landscape: immagine
                  @transform(format: "webp", width: 3840, height: 2160) {
                  id
                  url
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  width
                  height
                  title
                }
              }
            }
          }
        }
        sezioneImmagineTesto {
          ... on sezioneImmagineTesto_Entry {
            id
            portrait: immagine
              @transform(format: "webp", width: 1500, height: 1780) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            coloreTitolo
            coloreSfondo
            sectionTitle
            text
            invertiOrdine
            linkDefault
            label
          }
        }
        sezioneImmagineVideoFull {
          ... on sezioneImmagineVideoFull_Entry {
            imageVideoTitle
            imageVideoText
            fullVideoUrlPreview
            fullVideoUrl
            fullVideoButtonText
            fullImage {
              id
              title
            }
            landscape: fullImage
              @transform(format: "webp", width: 3840, height: 2160) {
              id
              url
              width
              srcset(sizes: ["750w", "1300w", "1920w"])
              height
              title
            }
            mobile: fullImageMobile
              @transform(format: "webp", width: 1000, height: 1500) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
          }
        }
      }
    }
  }
`
